export const STAFF_ROLE_PREFIX = "PF-PORTAL";

export enum RoleType {
  AGENT = "AGENT",
  MANAGER = "MANAGER",
  STAFF = "STAFF"
};
